<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <!-- <b-form-group>
      <label for="select-career" class="career-label">Carrera:</label>
      <b-form-select
        id="select-career"
        v-model="selected_career"
        :options="careers"
        value-field="id"
        text-field="name"
        class="w-25"
      >
        <template #first>
          <b-form-select-option value="null">
            -- Todas las Carreras --
          </b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group> -->
    <div>
      <h3 class="mt-3">
        {{
          $getVisibleNames("mesh.formationline", true, "Líneas de Formación")
        }}
        <AlternativeNameButton
          :table_name="'mesh.formationline'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_formationline'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.formationline',
                  false,
                  'Línea De Formación'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-formation-line-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Línea de Formación -->
        </div>
      </div>
      <GenericBTable
        :items="formation_lines"
        :pagination="formation_lines.length"
        :fields="formationLinesFields"
        :filter="input_search"
        :filterCustom="filterCustom"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @emitChangeSearchField="changeInputSearch"
      >
        <template #cell(faculties)="row">
          <div class="campus-container">
            <div
              v-for="item in getFacultyName(row.item.faculties)"
              :key="item.id"
              class="kl-chip"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template #cell(color)="row">
          <div
            class="formation-line-color"
            :style="{
              'background-color': row.item.color,
              color: row.item.color,
            }"
          >
            <!-- {{ row.item.color }} -->
          </div>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'mesh.change_formationline'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.formationline',
                  false,
                  'Línea De Formación'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-formation-line-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_formationline'"
            :click_button="() => askForDeleteFormationLine(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.formationline',
                  false,
                  'Línea De Formación'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-formation-line-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.formationline',
                  false,
                  'Línea De Formación'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <FormationLineForm
              :FormationLine="row.item"
              @updated="slotUpdatedFormationLine"
              :institution_id="row.item.school"
              :show_title="false"
            ></FormationLineForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-formation-line-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.formationline',
            false,
            'Línea De Formación'
          ),
        })
      "
      size="lg"
    >
      <FormationLineForm
        v-if="user"
        @created="slotCreatedFormationLine"
        :institution_id="user.school"
      ></FormationLineForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "FormationLineView",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    FormationLineForm: () =>
      import(
        "@/components/mesh/CurricularResources/FormationLine/FormationLineForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    // input_search: {
    //   type: String,
    //   default: "",
    // },
    display_id: {},
  },
  data() {
    return {
      selected_career: null,
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      formation_lines: names.FORMATION_LINES,
      careers: names.CAREERS,
      faculties: names.FACULTIES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.formationline",
            true,
            "Líneas de Formación"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.change_formationline");
      if (
        has_permission &&
        this.user &&
        (this.user.group_names.includes(
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
        ) ||
          this.user.is_superuser)
      )
        return has_permission;
      else return false;
    },
    formationLinesFields() {
      if (!this.allows_crud)
        return this.formation_lines_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.formation_lines_fields;
    },
    formation_lines_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.formationline",
              true,
              "Líneas De Formación"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: String(this.$t("reusable.common.description")),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "faculties",
          label: String(
            this.$getVisibleNames("mesh.faculty", true, "Facultades")
          ),
          tdClass: "text-left",
          thStyle: {
            width: "30%",
          },
          display_column: true,
        },
        {
          key: "color",
          label: String(this.$t("reusable.common.color")),
          sortable: false,
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(String(row.name), this.input_search) ||
        this.$filtered(String(row.description), this.input_search) ||
        this.faculties.filter(
          (x) =>
            this.$filtered(x.name, this.input_search) &&
            row.faculties.includes(x.id)
        ).length > 0
      ) {
        return true;
      } else {
        false;
      }
    },
    getFacultyName(faculties) {
      let list = [];
      faculties.forEach((x) => {
        const instance = this.faculties.find((element) => element.id == x);
        if (instance) list.push(instance);
      });
      return list;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    askForDeleteFormationLine(formation_line_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.formationline",
            false,
            "Línea De Formación"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_FORMATION_LINE, formation_line_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.formationline",
                    false,
                    "Línea De Formación"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedFormationLine() {
      this.$bvModal.hide("new-formation-line-modal");
    },
    slotUpdatedFormationLine(formation_line) {
      this.$bvModal.hide(`edit-formation-line-modal-${formation_line.id}`);
    },
    saveFormationLines(item) {
      this.$store.dispatch(
        names.UPDATE_FORMATION_LINE,
        (this.formation_line = item.id)
      );
      toast("Se actualizó: " + this.formation_line.name);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_FACULTIES);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
  },
  created() {},
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.career-label {
  padding-top: 0.3em;
  margin-right: 2%;
  font-weight: bold;
}
.campus-div {
  background-color: var(--primary-color);
  color: white;
  max-width: fit-content;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  flex-grow: 1;
  font-size: var(--thirth-font-size);
  text-align: center;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}
.title-header {
  margin-top: auto;
}
.formation-line-table {
  width: 100% !important;
}
.search-formation-line {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
.formation-line-color::before {
  min-width: 100px !important;
  height: 20px !important;
  opacity: 1;
  content: " #";
}
@media (max-width: 800px) {
  .search-formation-line {
    margin-right: 7.5%;
  }
}
</style>